import { CustomFieldDefinitionModels, CustomFieldDefinitionTypes } from '@nx-smartmonkey/shared/domain';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import BooleanIcon from '../../../assets/img/custom_field-boolean.svg';
import CategoricalIcon from '../../../assets/img/custom_field-categorical.svg';
import NumericalIcon from '../../../assets/img/custom_field-numerical.svg';
import TextIcon from '../../../assets/img/custom_field-text.svg';
import Client from '../../../assets/svg/custom-field-models/Client';
import StopCanceled from '../../../assets/svg/custom-field-models/StopCanceled';
import StopCompleted from '../../../assets/svg/custom-field-models/StopCompleted';
import Task from '../../../assets/svg/custom-field-models/Task';
import TaskCanceled from '../../../assets/svg/custom-field-models/TaskCancel';
import TaskCompleted from '../../../assets/svg/custom-field-models/TaskCompleted';
import Vehicle from '../../../assets/svg/custom-field-models/Vehicle';

type ProjectCustomFieldTypeIconProps = {
  fieldType?: CustomFieldDefinitionTypes | `categorical_multiple` | ``;
  iconSrc?: string;
};

export const ProjectCustomFieldTypeIcon = ({ fieldType, iconSrc }: ProjectCustomFieldTypeIconProps) => {
  if (iconSrc) return <img draggable="false" alt="" src={iconSrc} style={{ width: `12px`, height: `12px` }} />;
  if (fieldType) {
    let src;
    switch (fieldType) {
      case `text`:
        src = TextIcon;
        break;
      case `numerical`:
        src = NumericalIcon;
        break;
      case `boolean`:
        src = BooleanIcon;
        break;
      case `categorical`:
      case `categorical_multiple`:
        src = CategoricalIcon;
        break;
      default:
        return null;
    }
    return <img draggable="false" alt="" src={src} style={{ width: `12px`, height: `12px` }} />;
  }
  return null;
};

type ProjectCustomFieldCategoryIconProps = {
  fieldModel: CustomFieldDefinitionModels;
  selected?: boolean;
};

export const ProjectCustomFieldCategoryIcon = ({
  fieldModel,
  selected = false,
}: ProjectCustomFieldCategoryIconProps) => {
  switch (fieldModel) {
    case `task`:
      return <Task color={selected ? RoutalPalette.primary40 : RoutalPalette.secondary60} />;
    case `client`:
      return <Client color={selected ? RoutalPalette.primary40 : RoutalPalette.secondary60} />;
    case `vehicle`:
      return <Vehicle color={selected ? RoutalPalette.primary40 : RoutalPalette.secondary60} />;
    case `service_report_canceled`:
      return <StopCanceled color={selected ? RoutalPalette.primary40 : RoutalPalette.secondary60} />;
    case `service_report_completed`:
      return <StopCompleted color={selected ? RoutalPalette.primary40 : RoutalPalette.secondary60} />;
    case `service_report_task_completed`:
      return <TaskCompleted color={selected ? RoutalPalette.primary40 : RoutalPalette.secondary60} />;
    case `service_report_task_canceled`:
      return <TaskCanceled color={selected ? RoutalPalette.primary40 : RoutalPalette.secondary60} />;
    default:
      return null;
  }
};
